export default __webpack_public_path__ + "static/media/icp-logo.e94f872c.svg";